'use client'

import { useState, useEffect } from 'react'
import Link from 'next/link'
import Image from 'next/image'

export default function BrandLogosGrid({ logos }) {
    const [visibleCount, setVisibleCount] = useState(logos.length)

    // Shuffle logos on mount (client-side only to avoid server/client mismatch)
    const [shuffledLogos, setShuffledLogos] = useState(logos)

    useEffect(() => {
        // Fisher-Yates shuffle
        const shuffled = [...logos]
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1))
            ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
        }
        setShuffledLogos(shuffled)
    }, [logos])

    useEffect(() => {
        const calculateVisibleLogos = () => {
            if (shuffledLogos.length === 0) return

            // Calculate columns based on breakpoints: 5 cols at lg (1024px+), 3 cols at sm (640px+), 2 cols default
            const screenWidth = window.innerWidth
            let cols
            if (screenWidth >= 1024) {
                cols = 5
            } else if (screenWidth >= 640) {
                cols = 3
            } else {
                cols = 2
            }

            // Show only complete rows
            const completeRows = Math.floor(shuffledLogos.length / cols)
            const count = completeRows * cols
            setVisibleCount(count > 0 ? count : cols) // At least one row
        }

        calculateVisibleLogos()
        window.addEventListener('resize', calculateVisibleLogos)
        return () => window.removeEventListener('resize', calculateVisibleLogos)
    }, [shuffledLogos.length])

    const visibleLogos = shuffledLogos.slice(0, visibleCount)

    return (
        <section className="site-padding pt-6 pb-8 lg:pt-10 lg:pb-12 mb-8 lg:mb-12 bg-gray-2">
            <div className="flex items-baseline gap-3 lg:gap-4 mb-4 lg:mb-8">
                <h2 className="text-lg lg:text-xl font-light">Source from the best brands</h2>
                <Link href="/pages/category11/manufacturer" className="text-xs lg:text-sm text-gray-50 hover:text-primary underline">
                    View All
                </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-y-6 lg:gap-y-12 items-center">
                {visibleLogos.map((logo, index) => (
                    <div key={`${logo.supplier_id}-${index}`}>
                        {logo.url ? (
                            <Link href={logo.url}>
                                <Image
                                    src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${logo.file_name}`}
                                    alt={logo.alt_text}
                                    width={logo.width || 150}
                                    height={logo.height || 50}
                                    className="w-auto object-contain"
                                />
                            </Link>
                        ) : (
                            <Image
                                src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${logo.file_name}`}
                                alt={logo.alt_text}
                                width={logo.width || 150}
                                height={logo.height || 50}
                                className="w-auto object-contain"
                            />
                        )}
                    </div>
                ))}
            </div>
        </section>
    )
}
